// FETCH ALL PROPERTIES FROM ALL_OVER_PRINTING_DC DETAILS
export const FETCH_ALL_OVER_PRINTING_DC_DETAILS_REQUEST = 'FETCH_ALL_OVER_PRINTING_DC_DETAILS_REQUEST';
export const FETCH_ALL_OVER_PRINTING_DC_DETAILS_SUCCESS = 'FETCH_ALL_OVER_PRINTING_DC_DETAILS_SUCCESS';
export const FETCH_ALL_OVER_PRINTING_DC_DETAILS_FAILURE = 'FETCH_ALL_OVER_PRINTING_DC_DETAILS_FAILURE';

// FETCH ALL PROPERTIES FROM ALL_OVER_PRINTING_DC DETAILS
export const FETCH_ALL_OVER_PRINTING_DC_DETAILS_PROGRAM_REQUEST = 'FETCH_ALL_OVER_PRINTING_DC_DETAILS_PROGRAM_REQUEST';
export const FETCH_ALL_OVER_PRINTING_DC_DETAILS_PROGRAM_SUCCESS = 'FETCH_ALL_OVER_PRINTING_DC_DETAILS_PROGRAM_SUCCESS';
export const FETCH_ALL_OVER_PRINTING_DC_DETAILS_PROGRAM_FAILURE = 'FETCH_ALL_OVER_PRINTING_DC_DETAILS_PROGRAM_FAILURE';

// FETCH ALL PROPERTIES FROM ALL_OVER_PRINTING_DC DETAILS BY ID
export const FETCH_ALL_OVER_PRINTING_DC_DETAILS_BY_ID_REQUEST = 'FETCH_ALL_OVER_PRINTING_DC_DETAILS_BY_ID_REQUEST';
export const FETCH_ALL_OVER_PRINTING_DC_DETAILS_BY_ID_SUCCESS = 'FETCH_ALL_OVER_PRINTING_DC_DETAILS_BY_ID_SUCCESS';
export const FETCH_ALL_OVER_PRINTING_DC_DETAILS_BY_ID_FAILURE = 'FETCH_ALL_OVER_PRINTING_DC_DETAILS_BY_ID_FAILURE';

// CREATE PROPERTIES FOR ALL_OVER_PRINTING_DC DETAILS
export const CREATE_ALL_OVER_PRINTING_DC_DETAILS_REQUEST = 'CREATE_ALL_OVER_PRINTING_DC_DETAILS_REQUEST';
export const CREATE_ALL_OVER_PRINTING_DC_DETAILS_SUCCESS = 'CREATE_ALL_OVER_PRINTING_DC_DETAILS_SUCCESS';
export const CREATE_ALL_OVER_PRINTING_DC_DETAILS_FAILURE = 'CREATE_ALL_OVER_PRINTING_DC_DETAILS_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_ALL_OVER_PRINTING_DC_DETAILS = 'CREATE_USER_FORM_ALL_OVER_PRINTING_DC_DETAILS';

// UPDATE PROPERTIES FOR ALL_OVER_PRINTING_DC DETAILS
export const UPDATE_ALL_OVER_PRINTING_DC_DETAILS_REQUEST = 'UPDATE_ALL_OVER_PRINTING_DC_DETAILS_REQUEST';
export const UPDATE_ALL_OVER_PRINTING_DC_DETAILS_SUCCESS = 'UPDATE_ALL_OVER_PRINTING_DC_DETAILS_SUCCESS';
export const UPDATE_ALL_OVER_PRINTING_DC_DETAILS_FAILURE = 'UPDATE_ALL_OVER_PRINTING_DC_DETAILS_FAILURE';

// FETCH SINGLE ALL_OVER_PRINTING_DC_DETAILS
export const FETCH_SINGLE_ALL_OVER_PRINTING_DC_DETAILS_REQUEST = 'FETCH_SINGLE_ALL_OVER_PRINTING_DC_DETAILS_REQUEST';
export const FETCH_SINGLE_ALL_OVER_PRINTING_DC_DETAILS_SUCCESS = 'FETCH_SINGLE_ALL_OVER_PRINTING_DC_DETAILS_SUCCESS';
export const FETCH_SINGLE_ALL_OVER_PRINTING_DC_DETAILS_FAILURE = 'FETCH_SINGLE_ALL_OVER_PRINTING_DC_DETAILS_FAILURE';

// DELETE PROPERTIES FOR ALL_OVER_PRINTING_DC DETAILS
export const DELETE_ALL_OVER_PRINTING_DC_DETAILS_REQUEST = 'DELETE_ALL_OVER_PRINTING_DC_DETAILS_REQUEST';
export const DELETE_ALL_OVER_PRINTING_DC_DETAILS_SUCCESS = 'DELETE_ALL_OVER_PRINTING_DC_DETAILS_SUCCESS';
export const DELETE_ALL_OVER_PRINTING_DC_DETAILS_FAILURE = 'DELETE_ALL_OVER_PRINTING_DC_DETAILS_FAILURE';

// USERFORM RESET

export const ALL_OVER_PRINTING_DC_DETAILS_USERFORM_RESET = 'ALL_OVER_PRINTING_DC_DETAILS_USERFORM_RESET';

//DCNO
export const FETCH_ALL_OVER_PRINTING_DC_DETAILS_DC_NO_REQUEST = 'FETCH_ALL_OVER_PRINTING_DC_DETAILS_DC_NO_REQUEST';
export const FETCH_ALL_OVER_PRINTING_DC_DETAILS_DC_NO_SUCCESS = 'FETCH_ALL_OVER_PRINTING_DC_DETAILS_DC_NO_SUCCESS';
export const FETCH_ALL_OVER_PRINTING_DC_DETAILS_DC_NO_FAILURE = 'FETCH_ALL_OVER_PRINTING_DC_DETAILS_DC_NO_FAILURE';

//GRN NO
export const FETCH_GRN_NO_BY_ALL_OVER_PRINTING_DC_NO_REQUEST = 'FETCH_GRN_NO_BY_ALL_OVER_PRINTING_DC_NO_REQUEST';
export const FETCH_GRN_NO_BY_ALL_OVER_PRINTING_DC_NO_SUCCESS = 'FETCH_GRN_NO_BY_ALL_OVER_PRINTING_DC_NO_SUCCESS';
export const FETCH_GRN_NO_BY_ALL_OVER_PRINTING_DC_NO_FAILURE = 'FETCH_GRN_NO_BY_ALL_OVER_PRINTING_DC_NO_FAILURE';

export const FETCH_PRINTING_DC_PREVIOUS_LIST_REQUEST = 'FETCH_PRINTING_DC_PREVIOUS_LIST_REQUEST';
export const FETCH_PRINTING_DC_PREVIOUS_LIST_SUCCESS = 'FETCH_PRINTING_DC_PREVIOUS_LIST_SUCCESS';
export const FETCH_PRINTING_DC_PREVIOUS_LIST_FAILURE = 'FETCH_PRINTING_DC_PREVIOUS_LIST_FAILURE';

export const FETCH_PRINTING_DC_REPROCESS_PREVIOUS_LIST_REQUEST = 'FETCH_PRINTING_DC_REPROCESS_PREVIOUS_LIST_REQUEST';
export const FETCH_PRINTING_DC_REPROCESS_PREVIOUS_LIST_SUCCESS = 'FETCH_PRINTING_DC_REPROCESS_PREVIOUS_LIST_SUCCESS';
export const FETCH_PRINTING_DC_REPROCESS_PREVIOUS_LIST_FAILURE = 'FETCH_PRINTING_DC_REPROCESS_PREVIOUS_LIST_FAILURE';

export const ALL_OVER_PRINTING_DC_PROGRAM_ID_REQUEST = 'ALL_OVER_PRINTING_DC_PROGRAM_ID_REQUEST';
export const ALL_OVER_PRINTING_DC_PROGRAM_ID_SUCCESS = 'ALL_OVER_PRINTING_DC_PROGRAM_ID_SUCCESS';
export const ALL_OVER_PRINTING_DC_PROGRAM_ID_FAILURE = 'ALL_OVER_PRINTING_DC_PROGRAM_ID_FAILURE';

export const SHOW_PREVIOUS_LIST = 'SHOW_PREVIOUS_LIST';

